module.exports = __webpack_public_path__ + "static/img/pdf.d5e23a8a.svg";